module.exports = __webpack_public_path__ + "static/offices-content-image-tower-8e5eb56ff52edd54cf911f845f92c916.jpg";